import {stringify} from 'querystring';
import {routes} from './constants/';

export const sendEventKbArticleClick = eventId => fetch(`${routes.eventKbArticleClickedHandler}?${stringify({eventId})}`, {method: 'POST'});
export const sendGeneralKbArticleClick = kbUrl => fetch(`${routes.generalKbArticleClickedHandler}?${stringify({kbUrl})}`, {method: 'POST'});



// WEBPACK FOOTER //
// ./src/analytics.js